import React, { Component } from "react";

let selected = "tags-span-blue flex flex-ai-c";
let defaultColor = "tags-span-default flex flex-ai-c";

export default class Tag extends Component {
  render() {
    const { buttonText, onClicked, isSelected, onRemove, tag, onDelete } = this.props;

    return (
      <React.Fragment>
        {isSelected === true ? (
          <span
            className={selected}
            onClick={() => onClicked(tag)}
            style={{
              margin: "0.6rem",
              cursor: "pointer",
              padding: "0.4rem",
              borderRadius: "0.5rem",
            }}
          >
            {buttonText}
            <i className="fas fa-check-circle selected ml-1"></i>
          </span>
        ) : (
          <span
            style={{
              margin: "0.6rem",
              cursor: "pointer",
              padding: "0.4rem",
              borderRadius: "0.5rem",
            }}
            className={defaultColor}
          >
            {buttonText}
          
            {onRemove && (
              <i
                className="fas fa-plus-circle default ml-1 blue"
                onClick={() => onRemove(tag)}
                style={{ cursor: "pointer" }}
              ></i>
            )}

            {onDelete && (
              <i
                className="fas fa-times-circle default ml-1 danger"
                onClick={() => onDelete(tag)}
                style={{ cursor: "pointer" }}
              ></i>
            )}
          </span>
        )}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/TagsPopup/Tag.js